import React from 'react';

const RecordAlt = ({ className = '', title = '' }) => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" className={className}>
      <title lang="en">{title}</title>
      <circle cx="17" cy="17" r="17" fill="#F36A27"/>
      <circle cx="17" cy="17" r="13" fill="#F36A27" stroke="#FCEE21"/>
      <circle cx="17" cy="17" r="13" fill="#F36A27" stroke="#000000"/>
    </svg>
  )
};

export default RecordAlt;
